import AboutOne from "../Components/About/AboutOne";
import BlogOne from "../Components/Blog/BlogOne";
import Brand from "../Components/Brands/Brand";
import BrandCarouselOne from "../Components/Brands/BrandCarouselOne";
import CtaOne from "../Components/Cta/CtaOne";
import FaqOne from "../Components/Faq/FaqOne";
import FeaturesOne from "../Components/Features/FeaturesOne";
import FooterOne from "../Components/Footer/FooterOne";
import HeaderOne from "../Components/Header/HeaderOne";
// import HeroOne from "../Components/Hero/HeroOne";
import HeroTech from "../Components/Hero/HeroTech";
import HeroSocials from "../Components/Hero/HeroSocials";
import PortfolioOne from "../Components/Portfolio/PortfolioOne";
import ServicesOne from "../Components/Services/ServicesOne";
import TeamOne from "../Components/Team/TeamOne";
import TestimonialOne from "../Components/Testimonial/TestimonialOne";
import WorkProcess from "../Components/Work/WorkProcess";
const HomeOne = () => {
    return (
        <>
            <HeaderOne />
            <HeroSocials />
            {/* <HeroOne/> */}
            <HeroTech />
            <WorkProcess />
            <AboutOne />
            {/* <ServicesOne/>
        <CtaOne/>
        <FeaturesOne/> */}

            {/* <TestimonialOne/> */}
            <PortfolioOne />
            <BrandCarouselOne />
            {/* <TeamOne/>
        <FaqOne/> */}
            <BlogOne />
            <FooterOne />

            {/* Floating Sticky Buttons */}
            <div className="floating-action-btns">
                <a
                    href="https://wa.me/971502033924"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="fab-btn fab-whatsapp"
                    aria-label="WhatsApp"
                    style={{ color: '#fff' }}
                >
                    <i className="fab fa-whatsapp"></i>
                </a>
                <a
                    href="tel:+971502033924"
                    className="fab-btn fab-call"
                    aria-label="Call Now"
                    style={{ color: '#fff' }}
                >
                    <i className="fas fa-phone"></i>
                </a>
            </div>
        </>
    )
}

export default HomeOne;